<template>
  <div class="background">
    <div id="" class="absolute-mid card-container">
      <div class="mx-auto">
        <div class="header">
          AI-Assisted Daily Digest Enabled
        </div>
        <div class="description">
          <!-- Your report settings change is confirmed. Your following Daily Insight
          report will include an AI-generated summary, analysis, and
          recommendation. -->
          ยืนยันเปลี่ยนแปลงการตั้งค่ารีพอร์ตแล้ว จากนี้ ข้อมูลเชิงลึกแบบรายวันหรือ Daily Insight ของคุณจะมีการสรุปผล การวิเคราะห์ และคำแนะนำที่สร้างขึ้นโดย AI
        </div>
        <a :href="link" class="link">
          เรียนรู้เพิ่มเติมเกี่ยวกับข้อมูลเชิงลึกสำหรับหัวหน้าจาก Happily.ai
          <!-- Learn more about Happily.ai Insights for Managers -->
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
export default {
  name: "enable-ai-assist",
  data() {
    return {
      link: "https://happily.ai",
    };
  },
  created() {
    // //encode
    // const ciphertext = CryptoJS.AES.encrypt('pornsuda_c@dhas.com'+'||ai-assisted-enabled', 'HappilyAIEnabled').toString();
    // // const url = 'https://insights.happily.ai/enable-ai-assist?uid='+encodeURIComponent(ciphertext);
    // console.log('encodeURIComponent(ciphertext)',encodeURIComponent(ciphertext))
    let bytes = CryptoJS.AES.decrypt(
      this.$router.currentRoute.query.uid,
      "HappilyAIEnabled"
    );
    let originalText = bytes.toString(CryptoJS.enc.Utf8);
    if (originalText) {
      
    let codeSplit = originalText.split("||");
    this.$store.dispatch("monthlyInsignhts/updateEnable", codeSplit[0].replace(/\./g, "||"));
    }
    
  },
  mounted() {
    if (this.$route.params.id) {
      console.log(this.$route.params.id);
    }
  },
  // methods: {

  // },
};
</script>

<style lang="scss" scoped>
.background {
  position: relative;
  height: 100vh;
  width: 100vw;
  background-color: #f2f2f2;
}
.card-container {
  max-width: calc(500px - (100px));
  width: calc(100% - 100px);
  padding: 50px;
  background-color: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .header {
    font-size: 26px;
    font-weight: 900;
    color: #000;
    margin-bottom: 24px;
  }
  .description {
    font-size: 18px;
    color: #000;
    margin-bottom: 24px;
  }
  .link {
    font-size: 18px;
    color: #6d27bf;
    text-decoration: underline;
  }

  @media only screen and (max-width: 600px) {
    width: calc(100% - 64px);
    padding: 32px;
    border-radius: 8px;
    .header {
      font-size: 24px;
    }
    .header,
    .description {
      margin-bottom: 22px;
    }
  }

  @media only screen and (max-width: 400px) {
    width: calc(100% - 48px);
    padding: 24px;
    border-radius: 0;
    height: calc(100vh - 48px);
    display: flex;
    justify-content: center;
    align-items: center;
    .header {
      font-size: 20px;
    }
    .header,
    .description {
      margin-bottom: 18px;
    }
    .description,
    .link {
      font-size: 16px;
    }
  }
}
</style>
